import { API } from "aws-amplify";

export default async function selectSubscriptionPlan(body) {
    if (body?.plan_id) {
      return await API.post("subscription", "push-plan-to-queue", {
        body: body,
      });
    }
  }